import {
  AccountingCsvInput,
  readDoctolibCsvRow,
} from '@/utils/csv/accouting/doctolib-csv-file-reader';
import { csvReader } from '@/utils/csv/csv-reader';

export type AccountingFieldState = {
  type: 'warning' | 'error';
  message: string;
};

export const validateAccountingDoctolibCsvFile = async (
  csvFile: File,
): Promise<AccountingFieldState | null> => {
  let allSameMonth: boolean = true;
  let currentMonth: number | null = null;
  let hasData: boolean = false;

  await csvReader<AccountingCsvInput>({
    file: csvFile,
    callback: ({ row }) => {
      hasData = true;
      const readRow = readDoctolibCsvRow(row);

      // Skip row
      if (!readRow) {
        return;
      }

      const dateJs = new Date(readRow.date);
      if (currentMonth === null) {
        currentMonth = dateJs.getMonth();
      } else {
        allSameMonth = dateJs.getMonth() === currentMonth;
      }
    },
  });

  if (!hasData) {
    return {
      type: 'error',
      message:
        'import-accounting-doctor-attending-csv-form.import-csv.error.empty-file',
    };
  }

  if (!allSameMonth) {
    return {
      type: 'warning',
      message:
        'import-accounting-doctor-attending-csv-form.import-csv.warning.data-not-all-same-month',
    };
  }

  return null;
};
